import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const selectInfo = async (params: object) => {
  return await GET({ url: Api.selectInfo, params, showError: false })
}

export const cityStatus = async (params: object) => {
  return await GET({ url: Api.cityStatus, params, showError: false })
}

export const showInRecruit = async (params: object) => {
  return await GET({ url: Api.showInRecruit, params, showError: false })
}
